export default __webpack_public_path__ + "static/media/Tunic of Black Whispers.d918971e.jpg";